import { render } from "./RouteName.vue?vue&type=template&id=203a746a"
import script from "./RouteName.vue?vue&type=script&lang=js"
export * from "./RouteName.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__